import React from 'react';
import { Badge } from 'reactstrap';
import ToolTipItem from "../utils/tooltip";
import IconDownload from 'react-icons/lib/md/cloud-download';
import IconEye from 'react-icons/lib/md/remove-red-eye';
import IconMdDate from 'react-icons/lib/md/date-range';
import IconMdAirplanemodeActive from 'react-icons/lib/md/airplanemode-active';
import {appHelpers} from "../../_helpers";
import {appConstants} from "../../_constants";

const InvoicedRecord = ({report, getInvoiceIssuers}) => {
    const currencyCode =  String.fromCharCode(appHelpers.getCurrencyUnicode(report.Currency));
    return (
        <blockquote className="invoice-c blockquote invoiced">
            <h6 className="pull-left"><IconMdAirplanemodeActive size="18" color="#43a8df"/> {`${report.AirlineCode} - ${report.ProcessName}`}  </h6>
            <h6 className="pull-right">
                <ToolTipItem key={`${report.Id}InvoiceNumber`} title={ `${report.InvoiceNumber}` } content='Invoice Number' id={ `${report.Id}InvoiceNumber` }/>
            </h6>
            <footer style={{ paddingLeft: '20px'}} className="blockquote-footer blockquote-footer-clear clearfix">
                <div className="row mb-1">
                    <div className="col-sm-3">
                        <p className="m-0 tag">Invoiced (IATA)</p>
                    </div>
                    <div className="col-sm-2">
                        <p className="m-0 tag">Billed (NCAA)</p>
                    </div>
                    <div className="col-sm-2">
                        <p className="m-0 tag">Rebilled</p>
                    </div>
                    <div className="col-sm-2">
                        <p className="m-0 tag">Returned</p>
                    </div>
                    <div className="col-sm-3">
                        <p className="m-0 tag">Outstanding</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3">
                        <h6 className="text">
                            <span>{ currencyCode }</span>{appHelpers.numberWithCommas(report.IataAmount)}
                        </h6>
                    </div>
                    <div className="col-sm-2">
                        <h6 className="text">
                           {appHelpers.numberWithCommas(report.NcaaAmount)}
                        </h6>
                    </div>
                    <div className="col-sm-2">
                        <h6 className="text">
                           {appHelpers.numberWithCommas(report.Rebilled)}
                        </h6>
                    </div>
                    <div className="col-sm-2">
                        <h6 className="text">
                            {appHelpers.numberWithCommas(report.Returned)}
                        </h6>
                    </div>
                    <div className="col-sm-3">
                        <h6 className="text">
                            {appHelpers.numberWithCommas(report.Difference)}
                        </h6>
                    </div>
                </div>
                <div className="row mt-1">
                    <div className="col-sm-12 blockquote-footer ">
                          <span>
                               <IconMdDate size="14" color="#202021"/> <ToolTipItem key={`${report.Id}DateSupplied`} title={ appHelpers.formatDate(report.DateSupplied)} content='Process Date' id={ `${report.Id}DateSupplied` }/>
                          </span>&nbsp; | &nbsp;
                        <span>
                               <ToolTipItem key={`${report.Id}InvoiceDate`} title={ appHelpers.formatDate(report.InvoiceDate)} content='Invoice Date' id={ `${report.Id}InvoiceDate` }/>
                          </span>&nbsp;&nbsp;&nbsp;&nbsp;

                        <span>
                            <ToolTipItem key={`${report.Id}ConvertedAmount`} title={`${appHelpers.numberWithCommas(report.Converted)}`} content='Converted Amount' id={ `${report.Id}ConvertedAmount` }/>
                        </span> |&nbsp;&nbsp;
                        <span>
                            <ToolTipItem key={`${report.Id}ROE`} title={`${appHelpers.numberWithCommas(report.ROE)}`} content='ROE' id={ `${report.Id}ROE` }/>
                        </span>&nbsp;&nbsp;&nbsp;&nbsp;
                        <a href={`${appConstants.INVOICE_DOWNLOAD_URL}${report.InvoiceNumber}`} download>
                            <Badge className='pointer badge-success' key={ `${report.Id}Badge` }> <IconDownload size="14" color="#ffffff"/>&nbsp; Download Invoice &nbsp;</Badge>
                        </a>
                        &nbsp;&nbsp;
                        <Badge className='pointer badge-info' key={ `${report.Id}IssuerBadge` } onClick={ () => getInvoiceIssuers(report) }> <IconEye size="14" color="#ffffff"/>&nbsp; View Issuer &nbsp;</Badge>
                    </div>
                </div>
            </footer>
        </blockquote>
    );
};

export default InvoicedRecord;



// WEBPACK FOOTER //
// ./src/views/invoice/invoiced-record.js